import { useState } from 'react';
import { faqData } from '@/mocks/homeData';

export default function FaqSection() {
  const [openIds, setOpenIds] = useState<number[]>([1]);

  const toggleFaq = (id: number) => {
    setOpenIds((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading text-center text-foreground-950">
            常见问题
          </h2>
          <p className="mt-3 text-sm text-foreground-500 text-center">
            你关心的答案都在这里
          </p>

          <div className="mt-10 max-w-3xl mx-auto">
            <div className="space-y-3">
              {faqData.map((faq) => {
                const isOpen = openIds.includes(faq.id);
                return (
                  <div
                    key={faq.id}
                    className="bg-background-100 rounded-xl border border-background-200/70 overflow-hidden"
                  >
                    <button
                      onClick={() => toggleFaq(faq.id)}
                      className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer hover:bg-background-200/50 transition-colors duration-200"
                    >
                      <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                        {faq.question}
                      </h3>
                      <span className="w-6 h-6 rounded-full bg-background-300 flex items-center justify-center shrink-0 transition-transform duration-300"
                        style={{ transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)' }}
                      >
                        <i className="ri-add-line text-sm text-foreground-600"></i>
                      </span>
                    </button>
                    <div
                      className={`transition-all duration-300 overflow-hidden ${
                        isOpen ? 'max-h-[400px] opacity-100' : 'max-h-0 opacity-0'
                      }`}
                    >
                      <p className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}